import React from 'react';


import { makeStyles } from 'tss-react/mui';
import Typography from 'web-library/stories/atom/Typography/Typography';
import { useTranslation } from 'react-i18next';
import UnSupportedBrowserSVG from '../../assets/unsupported-browser.svg';
import DefaultHeaderEmpty from '../../components/DefaultHeaderEmpty';
import { useBrowserDetection } from '../../hooks/useBrowserDetection';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginBottom: theme.spacing(5),

    '& img': {
      position: 'relative',
      width: 400,
      height: 260,
    },
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  textContainerTitle: {
    color: theme.color.text.textHeader,
     ...typographyTheme(theme, 'h1'),
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginTop: theme.spacing(2),
  },
  messageContainerText: {
    color: theme.color.text.textSecondary,
     ...typographyTheme(theme, 'h4'),
  },
  browserName: {
    fontWeight: 900,
  },
}));

const UnSupportedBrowser = () => {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();
  const { browserName, browserVersion, osName } = useBrowserDetection();

  const browserClassName = cx({
    [classes.messageContainerText]: true,
    [classes.browserName]: true,
  });

  return (
    <>
      <DefaultHeaderEmpty />
      <div className={classes.root}>
        <img src={UnSupportedBrowserSVG} alt="unsupported-browser" />
        <div className={classes.textContainer}>
          <Typography className={classes.textContainerTitle}>
            {t('components->>UnSupportedBrowser.YourBrowserNotSupported')}
          </Typography>
          <div className={classes.messageContainer}>
            <Typography className={classes.messageContainerText}>
              {t('components->>UnSupportedBrowser.TryOneOfThessOptions')}
              <br /> Current browser [{browserName}({browserVersion})-({osName})].
            </Typography>
            <Typography className={`${browserClassName}`}>
              {t('components->>UnSupportedBrowser.SupportedBrowsers')}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};
export default UnSupportedBrowser;
